<template>
  <div>
    <div class="container">
      <div class="title-section">
        <h3>Build Your New Home!</h3>
        <p>Our easy selection tools guide you through the process of finding the perfect homesite, floorplan, and exterior.</p>
      </div>

      <div class="selector is-hidden-x">
        <router-link to="/community/lot">
          <div class="selector-container">
            <div class="journey-selector-tile">
              <div class="journey-selector-inner">
                <p class="selector-title">
                  EXPLORE
                </p>
                <p class="selector-title">
                  HOMESITES MAP
                </p>
              </div>
            </div>
            <div class="selector-tooltip">
              <p>
                Start your journey with the perfect lot and then find the perfect home and options to match it.
              </p>
            </div>
          </div>
        </router-link>
        <router-link to="/community/homes">
          <div class="selector-container">
            <div class="journey-selector-tile">
              <div class="journey-selector-inner">
                <p class="selector-title">
                  DISCOVER
                </p>
                <p class="selector-title">
                  HOME DESIGNS
                </p>
              </div>
            </div>
            <div class="selector-tooltip">
              <p>
                Start your journey with the perfect home and then find the perfect lot and options to match it.
              </p>
            </div>
          </div>
          
        </router-link>
        <router-link to="/community/move-in">
          <div class="selector-container">
            <div class="journey-selector-tile">
              <div class="journey-selector-inner">
                <p class="selector-title">
                  MOVE-IN
                </p>
                <p class="selector-title">
                  READY HOMES
                </p>
              </div>
            </div>
            <div class="selector-tooltip">
              <p>
                Browse move-in homes that are already under construction or completed.
              </p>
            </div>
          </div>
        </router-link>
      </div>

      <div class="selector is-hidden-t">
        <router-link to="/community/lot">
          <div class="selector-container">
            <div class="journey-selector-tile">
              <div class="journey-selector-inner">
                <p class="selector-title">
                  EXPLORE
                </p>
                <p class="selector-title">
                  HOMESITES MAP
                </p>
              </div>
            </div>
          </div>
        </router-link>
        <router-link to="/community/homes">
          <div class="selector-container">
            <div class="journey-selector-tile">
              <div class="journey-selector-inner">
                <p class="selector-title">
                  DISCOVER
                </p>
                <p class="selector-title">
                  HOME DESIGNS
                </p>
              </div>
            </div>
          </div>
          
        </router-link>
        <router-link to="/community/move-in">
          <div class="selector-container">
            <div class="journey-selector-tile">
              <div class="journey-selector-inner">
                <p class="selector-title">
                  MOVE-IN
                </p>
                <p class="selector-title">
                  READY HOMES
                </p>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

import Header from "@/components/journey/Header";

export default {
  name: 'community',
  mixins: [],
  components: {
    'app-header': Header
  },
  data() {
    return {}
  },
  watch: {},
  created() {
  },
  methods: {}
}
</script>




// WEBPACK FOOTER //
// src/components/journey/Selection.vue